import { MetaResponseMessages, ResponseMessages } from "@sms/shared/message/message.interface";
import { PayloadAction, createReducer, combineReducers, Reducer } from "@reduxjs/toolkit";
import { MessageRepeatedCountData } from "@sms/shared/message/message-repeated-count.interface";

import {
  getMessagesAction,
  getMessagesNextPageAction,
  handleCreateMessage,
  clearMessages,
  setMessages,
  setMessagesRepeated,
  setMetaMessages,
  setUpdateMessages,
  setInitMessages,
  setInitMetaMessages
} from "./messages.actions";

export interface MessagesStore {
  meta: MetaResponseMessages | null;
  messages: ResponseMessages[] | null;
  messagesRepeated: MessageRepeatedCountData[];
  isLoadingMessages: boolean;
}

export const messageReducer: Reducer<MessagesStore> = combineReducers({
  meta: createReducer<MetaResponseMessages | null>(null, builder =>
    builder
      .addCase(
        setInitMetaMessages,
        (_: MetaResponseMessages | null, { payload }: PayloadAction<MetaResponseMessages | null>) => payload
      )

      .addCase(
        setMetaMessages,
        (_: MetaResponseMessages | null, { payload }: PayloadAction<MetaResponseMessages | null>) => payload
      )
      .addCase(clearMessages, () => null)
  ),
  messages: createReducer<ResponseMessages[] | null>([], builder =>
    builder
      .addCase(
        setInitMessages,
        (_: ResponseMessages[] | null, { payload }: PayloadAction<ResponseMessages[] | null>) => payload
      )
      .addCase(setMessages, (messages: ResponseMessages[] | null, { payload }: PayloadAction<ResponseMessages[]>) => [
        ...(payload ?? []),
        ...(messages ?? [])
      ])
      .addCase(
        setUpdateMessages,
        (_: ResponseMessages[] | null, { payload }: PayloadAction<ResponseMessages[] | null>) => payload
      )
      .addCase(
        handleCreateMessage,
        (messages: ResponseMessages[] | null, { payload }: PayloadAction<ResponseMessages>) =>
          (messages ?? []).concat(payload)
      )
      .addCase(clearMessages, () => null)
  ),
  messagesRepeated: createReducer<MessageRepeatedCountData[]>([], builder =>
    builder.addCase(
      setMessagesRepeated,
      (_: MessageRepeatedCountData[] | null, { payload }: PayloadAction<MessageRepeatedCountData[]>) => payload
    )
  ),
  isLoadingMessages: createReducer<boolean>(false, builder =>
    builder
      .addCase(getMessagesAction, () => true)
      .addCase(getMessagesNextPageAction, () => true)
      .addCase(setInitMessages, () => false)
      .addCase(setMessages, () => false)
  )
});
